<template>
  <f7-page name="group-calendar">
    <f7-navbar
      :title="$t('common.groupCalendar')"
      :title-large="$t('common.groupCalendar')"
      back-link
      large
    />
    <AppLayout>
      <template #main>
        <CalendarView
          :group-id="groupId"
          :initial-event-id="initialEventId"
          :initial-start="initialStart"
        />
      </template>
    </AppLayout>
  </f7-page>
</template>

<script setup>
import AppLayout from "../components/common/AppLayout.vue";
import CalendarView from "../components/group/CalendarView.vue";

const props = defineProps({
  groupId: { type: String, required: true },
  f7route: { type: Object, default: null },
});

const initialEventId = props.f7route?.query?.eventId || null;
const initialStart = props.f7route?.query?.start || null;
</script>
